<template>
<div>
  <v-card>
    <!-- 頁面標題列（共用元件，融入卡片頂部） -->
    <ListPageHeader
      embedded
      title="經費核銷申請清單"
      subtitle="管理與追蹤各項經費核銷申請進度"
      icon="tabler-receipt"
      :count="pageCount"
    >
      <template #actions>
        <v-btn color="white" variant="flat" class="text-primary font-weight-bold" to="/tca/erm/ExpenseReimbursement">
          <VIcon icon="tabler-plus" class="mr-1" />建立申請
        </v-btn>
      </template>
    </ListPageHeader>

    <v-card-item>
      <div class="d-flex align-center mb-1">
        <VIcon icon="tabler-filter" size="20" class="text-primary mr-2" />
        <span class="text-subtitle-1 font-weight-medium">篩選條件</span>
      </div>
      <v-row class="pt-2 pb-5">
        <!-- <v-col cols="12" md="3">
          <v-text-field
            label="活動名稱"
            v-model="filters.applicationName"
          ></v-text-field>
        </v-col> -->
        <!-- <v-col cols="12" md="2">
          <v-select
            :items="associations"
            label="協會"
            v-model="filters.association"
          ></v-select>
        </v-col> -->
        <v-col cols="12" md="2">
          <v-text-field
            label="核銷申請單號"
            v-model="filters.reimburseApplyNo"
            clearable
            prepend-inner-icon="tabler-search"
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="1">
          <v-select
            :items="years"
            label="年度"
            v-model="filters.year"
            item-title="rocYear"
            item-value="adYear"
            clearable
          ></v-select>
        </v-col>
        <v-col cols="12" md="6">
          <v-autocomplete
            :items="applicants"
            label="經費核銷活動名稱"
            item-title="scheduleTitle"
            item-value="reimburseApplyNo"
            v-model="filters.applicant"
            clearable
            no-data-text="無活動名稱"
            prepend-inner-icon="tabler-search"
          ></v-autocomplete>
        </v-col>
        <v-col cols="12" md="3">
          <AppInput
            v-model="filters.status"
            type="select"
            :remoteItem="deSelectSelect"
            :remoteItemParams="{ tabId}"
            item-title="label"
            item-value="value"
            placeholder="請選擇狀態"
            :disabled="false"
            :loading="false"
            clearable
            :exclude="['Revoked', 'Passed', 'Resubmitted', 'Closed', 'ReturnedForRevision', 'Reviewing']"
            no-default-exclude
          />
        </v-col>
      </v-row>
    </v-card-item>

    <InteractiveDataTable
      v-model:items-per-page="filters.size"
      v-model:page="filters.page"
      :items-length="pageCount"
      :headers="headers"
      :items="applications"
      :loading="loading"
      empty-text="尚無經費核銷申請"
      empty-subtitle="可調整上方篩選條件，或點右上角「建立申請」新增"
      empty-icon="tabler-receipt-off"
      :items-per-page-options="[
        {value: 10, title: '10'},
        {value: 25, title: '25'},
        {value: 50, title: '50'},
        {value: 100, title: '100'},
      ]"
      :row-props="rowProps"
      :row-clickable="false"
      @row-click="markLastViewed"
      >
        <template v-slot:item.reimburseApplyNo="{ item }">
          <div class="d-inline-flex align-center flex-nowrap">
            <v-btn 
            @click.stop="edit(item)"
            color="primary" 
            variant="text" 
            class="pa-0 idt-link font-weight-bold"
            >
             {{item.expReimb.reimburseApplyNo}}
            </v-btn>
            <v-tooltip location="top" text="複製單號">
              <template #activator="{ props: tipProps }">
                <v-btn
                  v-bind="tipProps"
                  variant="text"
                  icon
                  size="x-small"
                  density="compact"
                  class="ms-1"
                  @click.stop="notifyCopyDocNo(item.expReimb.reimburseApplyNo)"
                >
                  <VIcon icon="tabler-copy" size="18" />
                </v-btn>
              </template>
            </v-tooltip>
          </div>
        </template>
        <template v-slot:item.activityName="{ item }">
          {{!!item.expReimb.activityName?item.expReimb.activityName:item.expReimb.itemName}}
        </template>
        <template v-slot:item.supplementary="{ item }">
          {{(item.expReimb.supplementary?(item.expReimb.supplementary=="Y"?'是':'否'):'')}}
        </template>
        <template v-slot:item.eventDate="{ item }">
          <div class="d-inline-flex flex-column text-medium-emphasis text-no-wrap">
            <span class="d-inline-flex align-center flex-nowrap">
              <VIcon icon="tabler-calendar-event" size="16" class="mr-1" />
              {{westernToRoc(item.expReimb.activityStartDate,'-','-')}}
            </span>
            <span class="d-inline-flex align-center flex-nowrap">
              <VIcon icon="tabler-arrow-down-right" size="16" class="mr-1" />
              {{westernToRoc(item.expReimb.activityEndDate,'-','-')}}
            </span>
          </div>
        </template>
        <template v-slot:item.status="{ item }">
            <Status 
            :status="item.expReimb.status" 
            :is-red="['Rejected', 'Revoke', 'Revoked']" 
            :is-green="['FPassed', 'SendAfterCorrect']"
            :is-warning="['Draft']"
            :is-info="[]"
            :is-purple="['ReturnedForRevision', 'MReturnedForRevision', 'CorrectAfterApprove']"
            :is-teal="['Reviewing', 'MApproved']"
            :is-indigo="['Resubmitted', 'MPassed']"
            :is-primary="['Submitted', 'FReturnedForRevision']" 
            :is-secondary="['Closed','FApproved']" 
            :shared-table-id="tabId" 
            btn-class="x-large" 
            font-class="18px" 
            :status-config="getStatusData" 
          />
        </template>
      </InteractiveDataTable>
  </v-card>
</div>
  <!-- <v-pagination v-model="page" :length="pageCount"></v-pagination> -->
</template>

<script setup lang="ts">
import Status from '../tnm/StatusComponenet.vue'
import { useDate } from 'vuetify'

definePage({
  meta: {
    action: 'manage', //固定為 manage
    subject: 'EXPENSEREIMBURSEMENTLIST', //系統代碼(系統授權設定中的系統代碼)
  },
})
import { computed, nextTick, onUnmounted, reactive } from "vue";
import { copyPlainText } from '@/utils/deUtil'
const router =useRouter()
const userCookieDapt = useStorage<any>('userData', {}).value.depNo
const date = useDate()
const filters= reactive( {
  applicationName: "",
  reimburseApplyNo: "",
  association: null,
  year: date.format(new Date(), 'year'),
  applicant: "",
  status: undefined,
  page: 1,
  size: 100,
})

const FILTER_STATE_KEY = 'erm_expense_reimbursement_list_filter_state'
const restoreListFilters = () => {
  try {
    const raw = sessionStorage.getItem(FILTER_STATE_KEY)
    if (!raw) return
    const saved = JSON.parse(raw) as Record<string, unknown>
    for (const k of Object.keys(filters) as (keyof typeof filters)[]) {
      if (k in saved) (filters as Record<string, unknown>)[k] = saved[k] as never
    }
  } catch { /* ignore */ }
}
const saveListFilters = () => {
  try {
    sessionStorage.setItem(FILTER_STATE_KEY, JSON.stringify({ ...filters }))
  } catch { /* ignore */ }
}
restoreListFilters()

const applicants= reactive( ["申請人1", "申請人2"])
const associations=reactive( ["協會1", "協會2"])
// const statuses=reactive( ["核銷通過", "初審通過", "回覆修正"])
const headers= reactive([
  { title: "申請單號", key: "reimburseApplyNo", icon: "tabler-file-text" },
  { title: "是否為補充核銷", key: "supplementary", icon: "tabler-copy-plus" },
  { title: "活動名稱", key: "activityName", icon: "tabler-clipboard-text" },
  { title: "經費預算名稱", key: "expReimb.projectTitle", icon: "tabler-report-money" },
  // { title: "項目名稱", key: "expReimb.applyNo" },
  { title: "活動日期", key: "eventDate", icon: "tabler-calendar-event" },
  // { title: "核銷總金額", key: "expense" },
  { title: "狀態", key: "status", icon: "tabler-flag" },
  // { title: "操作", key: "action" },
])
const applications=reactive<any[]>([])
const pageCount=ref(0)
const { setLastViewed: setLastClickedId, rowProps } = useLastViewedRow(
  'erm_expense_reimbursement_list_last_clicked',
  (item: any) => item?.expReimb?.reimburseApplyNo,
)

const markLastViewed = (item: any) => {
  setLastClickedId(item?.expReimb?.reimburseApplyNo)
}

/** API 載入中不顯示「尚無資料」，避免誤判 */
const loading = ref(true)

const { data: yearList, execute: fetchFilterYearList } = await useApi<any>(createUrl('/tca/expenserequestprojectlist/getYear', { query: {} }))
const years = computed(() => yearList ? yearList.value.data : 0);
const getApplyList = async () => {
  let year = filters.year?filters.year:''
  let association = userCookieDapt
  try {
    const response = await $api('/tca/expensereimbursementlist/getApplyList', {
      method: 'POST',
      body: {
        year,
        deptNo:association,
      },
    });
    // 检查响应的结构
    if (response && response.data && response.data.length > 0) {
      applicants.splice(0, applicants.length, ...response.data);
    } else {
      // 没有数据或错误情况
      applicants.splice(0, applicants.length);  // 清空 applicants
      console.error('Fetch error: no data received or response structure unexpected');
    }
  } catch (error) {
    console.error('Error during fetch:', error);
  }
}

// table data
const  fetchData =async() =>{
  let activityNameLike = filters.applicationName?filters.applicationName:null
  let deptNoEqual = userCookieDapt
  let belongYearEqual = filters.year?filters.year:null
  let reimbApplyNo = filters.reimburseApplyNo ? filters.reimburseApplyNo : (filters.applicant ? filters.applicant : null)
  let statusEqual = filters.status?filters.status:null
  let page = filters.page -1
  let size = filters.size
  try {
    loading.value = true
    const response = await $api('/tca/expensereimbursementlist/get', {
      method: 'POST',
      body: {
        activityNameLike,
        deptNoEqual,
        belongYearEqual,
        reimbApplyNo,
        statusEqual,
        page,
        size,
      },
    });

    if (response?.result != null) {
      applications.splice(0, applications.length, ...(response.result as any[]))
      pageCount.value = response.totalElements ?? 0
    } else {
      applications.splice(0, applications.length)
      pageCount.value = 0
      console.error('Fetch error:', response?.statusText);
    }
  } catch (error) {
    console.error('Error during fetch:', error);
    applications.splice(0, applications.length)
    pageCount.value = 0
  } finally{
    loading.value = false
  }
}
const edit = async (item: any) =>{
  setLastClickedId(item.expReimb.reimburseApplyNo)
  await nextTick()
  router.push({ path: '/tca/erm/ExpenseReimbursement', query: { reimburseApplyNo: item.expReimb.id } })
}

const notifyCopyDocNo = async (text: string | null | undefined) => {
  const ok = await copyPlainText(text)
  if (ok) {
    $swal({
      icon: 'success',
      title: '已複製到剪貼簿',
      toast: true,
      position: 'top-end',
      showConfirmButton: false,
      timer: 1500,
    })
  } else {
    $swal({
      icon: 'error',
      title: '複製失敗',
      toast: true,
      position: 'top-end',
      showConfirmButton: false,
      timer: 2000,
    })
  }
}

const tabId = ref('ExpenseReimbursement')
const { data: getStatusData, execute: fetchstatusDatas } = await useApi<any>(createUrl('/q/de/select/select/select/deSelect', {
  query: {
    tabId: tabId.value
  },
}))

onMounted(()=>{
  getApplyList()
  fetchData()
})
watch(() => filters.year,()=>{
  getApplyList()
})
watch(filters,()=>{
  fetchData()
})

onUnmounted(() => saveListFilters())

</script>

